import {
  Stepper,
  StepperDivider,
  StepperHighlight,
  StepperItem,
} from "@babackapp/customer-ui/components/stepper";
import {
  InfoIcon,
  SettingsIcon,
  ShoppingCartIcon,
  WalletIcon,
} from "lucide-react";
import { useLocation } from "react-router-dom";

export function LineItemStepper() {
  const { pathname } = useLocation();
  const step = pathname.split("/").pop();

  const stepState = (match: string, after: string[]) =>
    step === match ? "present" : after.includes(step!) ? "past" : "future";

  const labelClass = (match: string) =>
    step !== match ? "hidden @[340px]:inline" : undefined;

  return (
    <div className="flex gap-2 items-center -ml-0">
      <Stepper>
        <StepperItem
          state={stepState("line-item", [
            "reason",
            "resolution",
            "product-selection",
            "resolution-options",
          ])}
          style={{ cursor: "default" }}
        >
          {step === "line-item" && <StepperHighlight />}
          <ShoppingCartIcon />
          <span className={labelClass("line-item")}>Article</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={stepState("reason", [
            "resolution",
            "product-selection",
            "resolution-options",
          ])}
          style={{ cursor: "default" }}
        >
          {step === "reason" && <StepperHighlight />}
          <InfoIcon />
          <span className={labelClass("reason")}>Raison</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={stepState("resolution", ["product-selection", "resolution-options"])}
          style={{ cursor: "default" }}
        >
          {step === "resolution" && <StepperHighlight />}
          <WalletIcon />
          <span className={labelClass("resolution")}>Resolution</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={
            step === "product-selection"
              ? "present"
              : stepState("resolution-options", [])
          }
          style={{ cursor: "default" }}
        >
          {(step === "resolution-options" || step === "product-selection") && (
            <StepperHighlight />
          )}
          <SettingsIcon />
          <span className={labelClass("resolution-options")}>Options</span>
        </StepperItem>
      </Stepper>
    </div>
  );
}
